export default __webpack_public_path__ + "static/media/rarr.3aca1f72.PNG";